import { z } from 'zod/v4';

export const languageSchema = z.object({
  languageId: z.string(),
  language: z.string(),
  languageNative: z.string(),
});

export type Language = z.infer<typeof languageSchema>;
